const DownsampleRate = {
	NONE: "none",
	MINUTE: "minute",
	DAILY: "daily"
};
export default DownsampleRate;
